import { Accordion } from '../../../components/molecules/accordion/Accordion';
import tastify from '@frontastic/catwalk/src/js/helper/tastify';
import PropTypes from 'prop-types';
import React from 'react';

const AccordionTastic = (props) => {
  const { data, context } = props;
  if (!data) return null;

  const locale = context?.locale === 'en_AU@AUD' ? 'AU' : 'NZ';
  if (!data[`show${locale}`]) return null;

  return (
    <Accordion
      canOpenMultiple={data.canOpenMultiple}
      marginBottomMobile={data.marginBottomMobile}
      placement={data.placement}
    >
      {data.sections.map((item, index) => {
        return (
          <Accordion.Section
            isOpen={data.isOpen}
            backgroundColor={data.backgroundColor}
            title={`item${index}`}
            id={`item${index}`}
            key={`item${index}`}
            itemScope
            itemType="https://schema.org/Question"
          >
            <Accordion.Title
              isRotate={data.isRotate}
              timeout={data.timeout}
              itemprop="name"
            >
              {item.title}
            </Accordion.Title>
            <Accordion.Panel
              itemProp="acceptedAnswer"
              itemScope
              itemType="https://schema.org/Answer"
            >
              <p itemProp="text">{item.content}</p>
            </Accordion.Panel>
          </Accordion.Section>
        );
      })}
    </Accordion>
  );
};

AccordionTastic.propTypes = {
  data: PropTypes.object.isRequired,
  node: PropTypes.object.isRequired,
};

export default tastify({
  translate: true,
  connect: {
    context: true,
  }
})(AccordionTastic);
